module.exports = __webpack_public_path__ + "img/1.cdbb557e.jpg";